module.exports = __webpack_public_path__ + "img/bg2.69791a61.webp";